import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <>
            <footer className="bg-dark py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <img src="assets/images/logo.png" alt="logo" className="logo-dark" height={50} />
                            <p className="text-light text-opacity-50 mt-3 hover fs-4" >First Floor Maruti Darshan Complex,
                                <br /> Near Prakash Motors Hero Showroom,
                                <br /> Ganesh Chokdi, Anand, Gujarat
                                <br /><br />
                                <b>Phone : </b> +91 70164 07141<br />
                                <b>Email : </b> neelsoni@mysfs24.com
                            </p>
                            <ul className="social-list list-inline mt-3">
                                <li className="list-inline-item text-center fs-4" >
                                    <Link to="https://www.facebook.com/Sfspetlad?mibextid=ZbWKwL" target="_blank" className="social-list-item border-primary text-primary"><i className="mdi mdi-facebook" /></Link>
                                </li>
                                <li className="list-inline-item text-center fs-4">
                                    <Link to="https://www.instagram.com/sfs_cardlec?igsh=aWphaTY1cXZxdm4=" target="_blank" className="social-list-item border-danger text-danger"><i className="ri-instagram-fill" /></Link>
                                </li>
                                <li className="list-inline-item text-center fs-4">
                                    <Link to="https://www.linkedin.com/in/sai-financial-service-0a5153256?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" className="social-list-item border-info text-info"><i className="ri-linkedin-box-fill" /></Link>
                                </li>
                                <li className="list-inline-item text-center fs-4">
                                    <Link to=" https://wa.me/message/5DRQHVGGVBJGK1" target="_blank" className="social-list-item border-success text-success"><i className="ri-whatsapp-fill" /></Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-2 col-md-4 mt-3 mt-lg-0">
                            <h5 className="text-light">Our Pages</h5>
                            <ul className="list-unstyled ps-0 mb-0 mt-3">
                                <li className="mt-2"><Link to="/" className="text-light text-opacity-50 hover fs-4">Home</Link></li>
                                <li className="mt-2"><Link to="/about" className="text-light text-opacity-50 hover fs-4">About Us</Link></li>
                                <li className="mt-2"><Link to="/service" className="text-light text-opacity-50 hover fs-4">Services</Link></li>
                                <li className="mt-2"><Link to="/team" className="text-light text-opacity-50 hover fs-4">Team</Link></li>
                                <li className="mt-2"><Link to="/contact" className="text-light text-opacity-50 hover fs-4">Contact</Link></li>
                            </ul>
                        </div>
                        <div className="col-lg-2 col-md-4 mt-3 mt-lg-0">
                            <h5 className="text-light">Our Services</h5>
                            <ul className="list-unstyled ps-0 mb-0 mt-3">
                                <li className="mt-2"><a className="text-light text-opacity-50 hover fs-4">Credit Card</a></li>
                                <li className="mt-2"><a className="text-light text-opacity-50 hover fs-4">Credit Card Swipe</a></li>
                                <li className="mt-2"><a className="text-light text-opacity-50 hover fs-4" >Loan</a></li>
                                <li className="mt-2"><a className="text-light text-opacity-50 hover fs-4">Insurance</a></li>
                                <li className="mt-2"><a className="text-light text-opacity-50 hover fs-4">Pan Card Services</a></li>

                            </ul>
                        </div>
                        <div className="col-lg-2 col-md-4 mt-3 mt-lg-0">
                            <ul className="list-unstyled ps-0 mb-0 mt-3 hover" >
                                <li className="mt-2"><a className="text-light text-opacity-50 hover fs-4">Udyam</a></li>
                                <li className="mt-2"><a className="text-light text-opacity-50 hover fs-4">Voter ID Card</a></li>
                                <li className="mt-2"><a className="text-light text-opacity-50 hover fs-4">Income Tax Services</a></li>
                                <li className="mt-2"><a className="text-light text-opacity-50 hover fs-4    ">E-shram Card</a></li>

                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="mt-5">
                                <p className="text-light text-opacity-50 mt-4 text-center mb-0 hover">
                                    <b>© Copyright Sai Financial Service All Rights Reserved</b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer
